import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCustomerTypesPaginatedQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomerTypeDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CustomerTypeDocumentSortInput> | Types.CustomerTypeDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomerTypesPaginatedQuery = { __typename?: 'Query', customerTypes?: { __typename?: 'CustomerTypesConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerTypeDocument', id: string, customerTypeId: string, name: string, status: Types.CustomerTypeStatus, usageCount?: number | null, revenueGlAccountId: string, revenueGlAccount?: { __typename?: 'MergeDevAccountDocument', mergeDevAccountId: string, accountNumber: string, name: string, status: Types.MergeDevAccountStatus } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerTypeNamesByIdsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomerTypeDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomerTypeNamesByIdsQuery = { __typename?: 'Query', customerTypes?: { __typename?: 'CustomerTypesConnection', nodes?: Array<{ __typename?: 'CustomerTypeDocument', customerTypeId: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type AddCustomerTypeMutationVariables = Types.Exact<{
  input: Types.AddCustomerTypeInput;
}>;


export type AddCustomerTypeMutation = { __typename?: 'Mutation', addCustomerType: { __typename?: 'CustomerTypePayload', customerType?: { __typename?: 'CustomerTypeStateData', customerTypeId: string, name: string, revenueGlAccountId: string, status: Types.CustomerTypeStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateCustomerTypeMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerTypeInput;
}>;


export type UpdateCustomerTypeMutation = { __typename?: 'Mutation', updateCustomerType: { __typename?: 'CustomerTypePayload', customerType?: { __typename?: 'CustomerTypeStateData', customerTypeId: string, name: string, revenueGlAccountId: string, status: Types.CustomerTypeStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteCustomerTypeMutationVariables = Types.Exact<{
  input: Types.DeleteCustomerTypeInput;
}>;


export type DeleteCustomerTypeMutation = { __typename?: 'Mutation', deleteCustomerType: { __typename?: 'CustomerTypePayload', customerType?: { __typename?: 'CustomerTypeStateData', customerTypeId: string, name: string, revenueGlAccountId: string, status: Types.CustomerTypeStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null } };

export type SetCustomerTypeRevenueGlAccountMutationVariables = Types.Exact<{
  input: Types.SetCustomerTypeRevenueGlAccountInput;
}>;


export type SetCustomerTypeRevenueGlAccountMutation = { __typename?: 'Mutation', setCustomerTypeRevenueGlAccount: { __typename?: 'CustomerTypePayload', customerType?: { __typename?: 'CustomerTypeStateData', customerTypeId: string, name: string, revenueGlAccountId: string, status: Types.CustomerTypeStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CustomerTypeFragment = { __typename?: 'CustomerTypeStateData', customerTypeId: string, name: string, revenueGlAccountId: string, status: Types.CustomerTypeStatus };

export const CustomerTypeFragmentDoc = new TypedDocumentString(`
    fragment CustomerType on CustomerTypeStateData {
  customerTypeId
  name
  revenueGlAccountId
  status
}
    `, {"fragmentName":"CustomerType"});
export const GetCustomerTypesPaginatedDocument = new TypedDocumentString(`
    query GetCustomerTypesPaginated($where: CustomerTypeDocumentFilterInput, $order: [CustomerTypeDocumentSortInput!], $first: Int, $after: String) {
  customerTypes(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      id
      customerTypeId
      name
      status
      usageCount
      revenueGlAccountId
      revenueGlAccount {
        mergeDevAccountId
        accountNumber
        name
        status
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomerTypeNamesByIdsDocument = new TypedDocumentString(`
    query GetCustomerTypeNamesByIds($where: CustomerTypeDocumentFilterInput, $first: Int, $after: String) {
  customerTypes(where: $where, first: $first, after: $after) {
    nodes {
      customerTypeId
      name
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const AddCustomerTypeDocument = new TypedDocumentString(`
    mutation AddCustomerType($input: AddCustomerTypeInput!) {
  addCustomerType(input: $input) {
    customerType {
      ...CustomerType
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerType on CustomerTypeStateData {
  customerTypeId
  name
  revenueGlAccountId
  status
}`);
export const UpdateCustomerTypeDocument = new TypedDocumentString(`
    mutation UpdateCustomerType($input: UpdateCustomerTypeInput!) {
  updateCustomerType(input: $input) {
    customerType {
      ...CustomerType
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerType on CustomerTypeStateData {
  customerTypeId
  name
  revenueGlAccountId
  status
}`);
export const DeleteCustomerTypeDocument = new TypedDocumentString(`
    mutation DeleteCustomerType($input: DeleteCustomerTypeInput!) {
  deleteCustomerType(input: $input) {
    customerType {
      ...CustomerType
    }
    errors {
      code
      ...RecordValidationError
    }
  }
}
    fragment CustomerType on CustomerTypeStateData {
  customerTypeId
  name
  revenueGlAccountId
  status
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const SetCustomerTypeRevenueGlAccountDocument = new TypedDocumentString(`
    mutation SetCustomerTypeRevenueGlAccount($input: SetCustomerTypeRevenueGlAccountInput!) {
  setCustomerTypeRevenueGlAccount(input: $input) {
    customerType {
      ...CustomerType
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerType on CustomerTypeStateData {
  customerTypeId
  name
  revenueGlAccountId
  status
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerTypesPaginated: build.query<GetCustomerTypesPaginatedQuery, GetCustomerTypesPaginatedQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerTypesPaginatedDocument, variables })
    }),
    GetCustomerTypeNamesByIds: build.query<GetCustomerTypeNamesByIdsQuery, GetCustomerTypeNamesByIdsQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerTypeNamesByIdsDocument, variables })
    }),
    AddCustomerType: build.mutation<AddCustomerTypeMutation, AddCustomerTypeMutationVariables>({
      query: (variables) => ({ document: AddCustomerTypeDocument, variables })
    }),
    UpdateCustomerType: build.mutation<UpdateCustomerTypeMutation, UpdateCustomerTypeMutationVariables>({
      query: (variables) => ({ document: UpdateCustomerTypeDocument, variables })
    }),
    DeleteCustomerType: build.mutation<DeleteCustomerTypeMutation, DeleteCustomerTypeMutationVariables>({
      query: (variables) => ({ document: DeleteCustomerTypeDocument, variables })
    }),
    SetCustomerTypeRevenueGlAccount: build.mutation<SetCustomerTypeRevenueGlAccountMutation, SetCustomerTypeRevenueGlAccountMutationVariables>({
      query: (variables) => ({ document: SetCustomerTypeRevenueGlAccountDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerTypesPaginatedQuery, useLazyGetCustomerTypesPaginatedQuery, useGetCustomerTypeNamesByIdsQuery, useLazyGetCustomerTypeNamesByIdsQuery, useAddCustomerTypeMutation, useUpdateCustomerTypeMutation, useDeleteCustomerTypeMutation, useSetCustomerTypeRevenueGlAccountMutation } = injectedRtkApi;
